/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Interval_Every_WeeksInputs */

const en_plan_interval_every_weeks = /** @type {(inputs: Plan_Interval_Every_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every ${i?.count} weeks`)
};

const es_plan_interval_every_weeks = /** @type {(inputs: Plan_Interval_Every_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cada ${i?.count} semanas`)
};

/**
* | output |
* | --- |
* | "Every {count} weeks" |
*
* @param {Plan_Interval_Every_WeeksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_interval_every_weeks = /** @type {((inputs: Plan_Interval_Every_WeeksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Interval_Every_WeeksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_interval_every_weeks(inputs)
	return en_plan_interval_every_weeks(inputs)
});